<template>
  <footer class="p-4">
    <div class="container mx-auto">
      <div>
        <span class="text-gray-600">Follow Biew</span>
        <div class="flex items-center">
          <a href="https://twitter.com/getbiew">
            <img
              class="h-8"
              src="@/assets/icons/twitter-squared.svg"
              alt="twitter"
            />
          </a>
        </div>
      </div>
      <div class="mt-4 text-gray-500">
        © 2020 Biew all rights reserved
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "TheFooter"
};
</script>
